import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

const Approach = () => {
  const [ref, revealed] = useScrollReveal(0.15);
  const steps = [
    {
      number: '1',
      title: 'Unverbindliche Kurzanalyse',
      description: 'Schnelle Einordnung Ihrer Versandstruktur und ersten Potenzialabschätzung in einem 20-30 minütigen Gespräch'
    },
    {
      number: '2',
      title: 'Klare Einschätzung',
      description: 'Transparent und ehrlich: Bewertung von Einsparpotenzialen, Aufwand und Umsetzbarkeit für Ihre Situation'
    },
    {
      number: '3',
      title: 'Zielstruktur entwickeln',
      description: 'Entwicklung eines maßgeschneiderten Konzepts für Ihre Briefkonsolidierung mit realistischem Einsparfahrplan'
    },
    {
      number: '4',
      title: 'Begleitete Umsetzung',
      description: 'Ich setze die Umstellung mit Ihnen um – bis zum stabilen Regelbetrieb. Sie behalten die Kontrolle.'
    },
    {
      number: '5',
      title: 'Transparente Konditionen von Anfang an',
      description: 'Die Beratung ist für Sie kostenfrei. Vergütet werde ich über die Umsetzung – meine Konditionen lege ich offen, bevor Sie entscheiden. So behalten Sie jederzeit die volle Kostenkontrolle.'
    }
  ];

  return (
    <section id="arbeitsweise" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div
          ref={ref}
          className={`max-w-4xl mx-auto reveal-on-scroll ${revealed ? 'revealed' : ''}`}
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-6 text-center">
            Arbeitsweise
          </h2>
          <p className="text-lg text-slate-600 mb-16 text-center leading-relaxed">
            Strukturiert, transparent und mit Fokus auf Ihre operative Sicherheit
          </p>

          <div className="relative">
            {/* Vertical connecting line with gradient */}
            <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-gradient-to-b from-slate-300 via-slate-400 to-slate-300 hidden lg:block"></div>

            <div className="space-y-12">
              {steps.map((step, index) => (
                <div key={index} className="relative flex items-start gap-6 group">
                  {/* Step number circle with enhanced effects */}
                  <div className="flex-shrink-0 relative z-10">
                    <div className="w-16 h-16 text-slate-900 rounded-full flex items-center justify-center text-2xl font-bold shadow-lg group-hover:shadow-2xl group-hover:scale-110 transition-all duration-300 relative overflow-hidden" style={{ backgroundColor: '#FFA266' }}>
                      {/* Shine effect on hover */}
                      <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                      <span className="relative z-10">{step.number}</span>
                    </div>
                  </div>

                  {/* Step content with glassmorphism */}
                  <div className="flex-1 pt-2 p-6 rounded-lg bg-slate-50/50 backdrop-blur-sm border border-slate-100 group-hover:border-slate-300 group-hover:shadow-lg transition-all duration-300">
                    <h3 className="text-xl font-semibold text-slate-900 mb-3 group-hover:text-slate-800 transition-colors">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed group-hover:text-slate-700 transition-colors">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Approach;